export default {
  historyDelimiter: '-----------'
};
